/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Py_ScopeInputs */

const es_marketplace_seo_license_row_py_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Py_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación diurna hasta 150 millas.`)
};

const gl_marketplace_seo_license_row_py_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Py_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación diurna ata 150 millas.`)
};

const en_marketplace_seo_license_row_py_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Py_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day navigation up to 150 miles.`)
};

/**
* | output |
* | --- |
* | "Day navigation up to 150 miles." |
*
* @param {Marketplace_Seo_License_Row_Py_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_py_scope = /** @type {((inputs?: Marketplace_Seo_License_Row_Py_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Py_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_py_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_py_scope(inputs)
	return es_marketplace_seo_license_row_py_scope(inputs)
});